import { AppStateValue } from '../../AppState';
import { Ticket } from '../../shared/interfaces/ticket.interface';
import { withArchived } from '../../shared/utils/archivedPickers';
import {
  getCategory,
  getGroup,
  getPriority,
  getStatus,
  getTicketType,
  getTeam,
} from '../ticketHelper';

/**
 * The lookups the mobile ticket list spreads over each ticket before handing it to the card.
 *
 * Status must be the whole status record, not just its name: `TicketStatus` picks the pill
 * colour by `Guid`, so a `{ Value }` alone rendered every status blue (bug 32817).
 */
export const getMobileTicketProperties = (ticket: Ticket, state: AppStateValue) => ({
  Status: ticket.StatusId == null ? 'No Status' : getStatus(ticket.StatusId, withArchived(state.ticketStatus, state.archivedTicketStatus)),
  Team: ticket.TeamId == null ? '' : { FriendlyName: getTeam(ticket.TeamId, state)?.FriendlyName },
  SupportGroup: ticket.SupportGroupId == null ? '' : { Name: getGroup(ticket.SupportGroupId, state)?.Name },
  Category: ticket.CategoryId == null ? 'No Category' : getCategory(ticket.CategoryId, withArchived(state.categories, state.archivedCategories)),
  Priority: ticket.PriorityId == null ? 'No Priority' : getPriority(ticket.PriorityId, withArchived(state.priority, state.archivedPriority)),
  TicketType: ticket.TicketTypeId == null ? 'No Type' : getTicketType(ticket.TicketTypeId, withArchived(state.ticketTypes, state.archivedTicketTypes))
});
